import { Button, Stack } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import useSafeAreaInsets from "hooks/useSafeAreaInsets";
import { theme } from "styles/theme";
import ContentTemplateV2 from "../content/ContentTemplateV2";
import image19 from "static/image/payment/typec/660_19.png";
import payback from "static/image/payment/typec/payback.png";
import descision from "static/image/payment/typec/decision.png";
import image20 from "static/image/payment/typec/660_20.png";
import FloatingAreaPromotion from "../../common/FloatingAreaPromotion";
import image1 from "../../../static/image/payment/typec/660_1.png";
import image2 from "../../../static/image/payment/typec/660_2.png";
import image3 from "../../../static/image/payment/typec/660_3.png";
import image4 from "../../../static/image/payment/typec/660_4.png";
import image5 from "../../../static/image/payment/typec/660_5.png";
import image6 from "../../../static/image/payment/typec/660_6.png";
import image7 from "../../../static/image/payment/typec/660_7.png";
import image8 from "../../../static/image/payment/typec/660_8.gif";
import image9 from "../../../static/image/payment/typec/660_9.png";
import image10 from "../../../static/image/payment/typec/660_10.png";
import image11 from "../../../static/image/payment/typec/660_11.png";
import image12 from "../../../static/image/payment/typec/660_12.png";
import image13 from "../../../static/image/payment/typec/660_13.png";
import image14 from "../../../static/image/payment/typec/660_14.png";
import image15 from "../../../static/image/payment/typec/660_15.png";
import image16 from "../../../static/image/payment/typec/660_16.png";
import image17 from "../../../static/image/payment/typec/660_17.png";
import image18 from "../../../static/image/payment/typec/660_18.png";
import { useNavigate } from "react-router-dom";
import useMixpanelWeb from "../../../hooks/useMixpanelWeb";
import BackButton from "../../common/BackButton";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "../../../api/onboardingApi";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../recoil/userAtom";

export default function ProductContent() {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const fullWidth = true;

  const user = useRecoilValue(userAtom);
  const navigate = useNavigate();

  const isPaybackPolicy =
    user?.refundPolicyType !== "c" && user?.refundPolicyType !== "b";

  const trackMixpanel = useMixpanelWeb({
    eventName: "상품 상세 페이지 진입",
    params: {
      event_source: "app",
    },
  });

  const pageKey = "product_1";
  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
    trackMixpanel();
  });

  const { bottom: safeBottom } = useSafeAreaInsets();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - safeBottom
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  const handleBack = () => {
    if (user?.onboardingType === "f") {
      navigate("/onboarding_new/introduction/6", { replace: true });
    } else {
      navigate("/onboarding_new/curriculum/1", { replace: true });
    }
  };

  const body = (
    <ContentTemplateV2
      fullBleed
      disableBottomSafeArea
      isWide
      setContainerHeight={setContainerHeight}
    >
      <Stack
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "60px",
          backgroundColor: "transparent",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "660px",
            px: "8px",
            height: "100%",
          }}
        >
          <BackButton
            onBack={handleBack}
            iconColor={theme.vars.palette.Content.Negative}
          />
        </Stack>
      </Stack>
      {containerHeight > 0 && (
        <Stack
          sx={{
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <Stack
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
            }}
          >
            <img
              src={image1}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image2}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image3}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image4}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image5}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image6}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image7}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />{" "}
            <img
              src={image8}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image9}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image10}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image11}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image12}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image13}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image14}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image15}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image16}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image17}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image18}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            {!isPaybackPolicy ? (
              <img
                src={image19}
                alt={"empty"}
                style={{
                  width: "100%",
                }}
              />
            ) : (
              <>
                <img
                  src={payback}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={descision}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
              </>
            )}
            <img
              src={image20}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
          </Stack>

          <FloatingAreaPromotion
            fullWidth={fullWidth}
            ref={floatingAreaRef}
            noDivider={true}
            backgroundColor={"transparent"}
            paddingBottom={"8px"}
          >
            <Stack
              spacing={1.5}
              sx={{ width: "100%" }}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Stack
                spacing={"16px"}
                sx={{
                  width: "100%",
                  mx: "auto",
                  paddingBottom: "8px",
                }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <Button
                  onClick={() => {
                    navigate("/onboarding_new/payment/1", { replace: true });
                  }}
                  size={"lg"}
                  variant={"Soft"}
                  sx={{
                    width: "100%",
                    fontWeight: 700,
                  }}
                >
                  {"지금 시작하기"}
                </Button>
              </Stack>
            </Stack>
          </FloatingAreaPromotion>
        </Stack>
      )}
    </ContentTemplateV2>
  );

  return body;
}
